/**
 * What the multi-select's "Select all" row says, for the rows it would act on.
 *
 * While inactive options are hidden behind "Show archived", the row selects the
 * listed (active) ones only, so a report run on it leaves the archived and
 * on-hold projects' hours out. Before HW-951 the same click picked every
 * project; the label says "active" so the narrower answer is never mistaken
 * for "all projects". A selected inactive option still listed then is not
 * counted: it is not active, and it is already selected. [HW-951]
 */
export function selectAllLabel({
  rows,
  searching,
  inactiveHidden,
}: {
  rows: readonly { inactive?: boolean }[];
  searching: boolean;
  inactiveHidden: boolean;
}): string {
  const count = inactiveHidden ? rows.filter((row) => !row.inactive).length : rows.length;
  const scope = inactiveHidden ? ' active' : '';
  return searching ? `Select all matching${scope} (${count})` : `Select all${scope} (${count})`;
}
